/* eslint-disable react/jsx-no-duplicate-props */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { Table } from "antd";
import { toast, ToastContainer } from "react-toastify";
import PropTypes from "prop-types";
import "react-toastify/dist/ReactToastify.css";
import SidebarAdmin from "../SidebarAdmin";
import BusinessHeader from "../BusinessHeader";
import config from "../../config";
import { blogimg2 } from "../imagepath";
import { usePermission } from "../../PermissionContext";

// CustomToast component for reactivation confirmation
const CustomToast = ({ closeToast, onConfirm, doctorId }) => (
  <div style={{ textAlign: "center", position: "relative" }}>
    <p style={{ fontSize: "16px", fontWeight: "bold" }}>
      ⚠️ Are you sure you want to reactivate this doctor?
    </p>
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: "10px",
        marginTop: "10px",
      }}
    >
      <button
        onClick={() => {
          onConfirm(doctorId);
          closeToast();
        }}
        style={{
          background: "green",
          color: "white",
          border: "none",
          padding: "5px 15px",
          cursor: "pointer",
          borderRadius: "5px",
        }}
      >
        Yes
      </button>
      <button
        onClick={closeToast}
        style={{
          background: "red",
          color: "white",
          border: "none",
          padding: "5px 15px",
          cursor: "pointer",
          borderRadius: "5px",
        }}
      >
        No
      </button>
    </div>
    <button
      onClick={closeToast}
      style={{
        position: "absolute",
        top: "10px",
        right: "10px",
        background: "transparent",
        border: "none",
        fontSize: "16px",
        cursor: "pointer",
      }}
    >
      ✕
    </button>
  </div>
);

// PropTypes for CustomToast
CustomToast.propTypes = {
  closeToast: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  doctorId: PropTypes.string.isRequired,
};

const ArchiveDoctor = () => {
  const { permissions } = usePermission();
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [loading, setLoading] = useState(true);

  // Permission checks
  const hasViewPermission = permissions?.view_archive_doctors_list === 1;
  const hasReactivatePermission = permissions?.reactivate_archive_doctor === 1;

  // Debugging permissions
  useEffect(() => {
    console.log("Permissions in ArchiveDoctor:", permissions);
    console.log("Type of permissions:", typeof permissions);
    console.log("Is permissions an array?", Array.isArray(permissions));
    console.log("Has view_archive_doctors_list?", permissions?.view_archive_doctors_list === 1);
    console.log("Has reactivate_archive_doctor?", permissions?.reactivate_archive_doctor === 1);
  }, [permissions]);

  // Fetch archived doctors
  const fetchDoctors = async () => {
    try {
      const businessID = localStorage.getItem("BusinessID");
      if (!businessID) {
        toast.error("Business ID is missing", {
          position: "top-center",
          toastId: "business-id-error",
        });
        return;
      }
      const response = await fetch(
        `${config.API_URL}get_archive_business_doctors.php?business_id=${businessID}`
      );
      const result = await response.json();

      if (result.status === "success") {
        const mappedDoctors = result.doctors.map((doctor, index) => ({
          ...doctor,
          key: doctor.doctor_id || index,
          department_names: doctor.department_names || "N/A",
        }));
        setData(mappedDoctors);
        setOriginalData(mappedDoctors);
      } else {
        toast.error(result.message || "Failed to fetch archived doctors", {
          position: "top-center",
          toastId: "fetch-error",
        });
      }
    } catch (error) {
      console.error("Error fetching archived doctors:", error);
      toast.error("Failed to fetch archived doctors", {
        position: "top-center",
        toastId: "fetch-network-error",
      });
    } finally {
      setLoading(false);
    }
  };

  // Handle search
  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchText(searchValue);
    if (searchValue === "") {
      setData(originalData);
    } else {
      const filtered = originalData.filter((doctor) => {
        return (
          (doctor.full_doctor_name || "").toLowerCase().includes(searchValue) ||
          (doctor.education || "").toLowerCase().includes(searchValue) ||
          (doctor.email || "").toLowerCase().includes(searchValue) ||
          (doctor.phone || "").toLowerCase().includes(searchValue) ||
          (doctor.Aadhaar_number || "").toLowerCase().includes(searchValue) ||
          (doctor.pan_number || "").toLowerCase().includes(searchValue) ||
          (doctor.department_names || "").toLowerCase().includes(searchValue)
        );
      });
      setData(filtered);
    }
  };

  // Handle reactivate
  const onReactivateClick = (doctorId) => {
    if (!hasReactivatePermission)
    //    {
    //   toast.error("You do not have permission to reactivate doctors.", {
    //     position: "top-center",
    //     toastId: "permission-error",
    //   });
    //   return;
    // }

    // Prevent multiple confirmation toasts
    if (toast.isActive("reactivate-confirm")) {
      return;
    }

    const handleConfirmReactivate = async (id) => {
      try {
        const businessID = localStorage.getItem("BusinessID");
        if (!businessID) {
          toast.error("Business ID is missing", {
            position: "top-center",
            toastId: "business-id-error",
          });
          return;
        }
        const response = await fetch(
          `${config.API_URL}reactivate_doctor.php?business_id=${businessID}&doctor_id=${id}`,
          { method: "GET" }
        );
        const result = await response.json();

        if (result.status === "success") {
          toast.success("Doctor reactivated successfully.", {
            position: "top-center",
            toastId: "reactivate-success",
          });
          setData((prevData) =>
            prevData.filter((doctor) => doctor.doctor_id !== id)
          );
        } else {
          toast.error("Failed to reactivate doctor: " + result.message, {
            position: "top-center",
            toastId: "reactivate-error",
          });
        }
      } catch (error) {
        console.error("Error reactivating doctor:", error);
        toast.error("Something went wrong! Please try again.", {
          position: "top-center",
          toastId: "reactivate-network-error",
        });
      } finally {
        toast.dismiss("reactivate-confirm");
      }
    };

    toast(
      <CustomToast
        onConfirm={handleConfirmReactivate}
        doctorId={doctorId}
      />,
      {
        toastId: "reactivate-confirm",
        position: "top-center",
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        closeButton: true,
      }
    );
  };

  // Table columns
  const columns = [
    {
      title: "SR No.",
      dataIndex: "index",
      render: (text, record, index) =>
        (currentPage - 1) * itemPerPage + index + 1,
    },
    {
      title: "Doctor Name",
      dataIndex: "full_doctor_name",
      render: (text, record) => (
        <h2 className="profile-image">
          <Link to="#" className="avatar avatar-sm me-2">
            <img
              className="avatar-img rounded-circle"
              src={
                record.profile_image
                  ? `${config.API_URL}Uploads/profile_images/doctor_images/${record.profile_image}`
                  : blogimg2
              }
              alt="User Image"
            />
          </Link>
          <Link to="#">{record.full_doctor_name}</Link>
        </h2>
      ),
      sorter: (a, b) =>
        (a.full_doctor_name || "").localeCompare(b.full_doctor_name || ""),
    },
    {
      title: "Education",
      dataIndex: "education",
      sorter: (a, b) => (a.education || "").localeCompare(b.education || ""),
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: (a, b) => (a.email || "").localeCompare(b.email || ""),
    },
    {
      title: "Phone",
      dataIndex: "phone",
      sorter: (a, b) => (a.phone || "").localeCompare(b.phone || ""),
    },
    {
      title: "Department",
      dataIndex: "department_names",
      sorter: (a, b) =>
        (a.department_names || "").localeCompare(b.department_names || ""),
    },
    {
      title: "Joining Date",
      dataIndex: "joining_date",
      sorter: (a, b) => new Date(a.joining_date) - new Date(b.joining_date),
      render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
    },
    {
      title: "Archive Date",
      dataIndex: "archive_date",
      sorter: (a, b) => new Date(a.archive_date) - new Date(b.archive_date),
      render: (date) => (date ? new Date(date).toLocaleDateString() : "N/A"),
    },
    {
      title: "",
      dataIndex: "actions",
      render: (text, record) => (
        <div className="text-end">
          <div className="dropdown dropdown-action">
            <Link
              to="#"
              className="action-icon dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fas fa-ellipsis-v" />
            </Link>
            <div className="dropdown-menu dropdown-menu-end">
              {hasReactivatePermission && (
                <button
                  className="dropdown-item"
                  onClick={() => onReactivateClick(record.doctor_id)}
                >
                  <i className="fas fa-redo me-2" />
                  Reactivate
                </button>
              )}
            </div>
          </div>
        </div>
      ),
    },
  ];

  // Fetch data on component mount
  useEffect(() => {
    if (hasViewPermission) {
      fetchDoctors();
    } else {
      console.log("No permission to fetch archived doctors");
      // toast.error("You do not have permission to view the archived doctor list.", {
      //   position: "top-center",
      //   toastId: "permission-error",
      // });
    }
  }, [hasViewPermission]);

  // Pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  if (!hasViewPermission) {
    return (
      <div>
        <BusinessHeader />
        <SidebarAdmin
          id="menu-item1"
          id1="menu-items1"
          activeClassName="archive-doctor"
        />
        <div className="page-wrapper">
          <div className="content">
            <div className="alert alert-fill alert-danger alert-icon">
              <FeatherIcon icon="cross-circle" />
              <strong>Access Denied</strong>! You do not have permission to view the archived doctor list.
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <ToastContainer />
      <BusinessHeader />
      <SidebarAdmin
        id="menu-item1"
        id1="menu-items1"
        activeClassName="archive-doctor"
      />
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/doctorlist">Doctors</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <FeatherIcon icon="chevron-right" />
                  </li>
                  <li className="breadcrumb-item active">Archive Doctors</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table show-entire">
                <div className="card-body">
                  {/* Table Header */}
                  <div className="page-table-header mb-2">
                    <div className="row align-items-center">
                      <div className="col">
                        <div className="doctor-table-blk">
                          <h3>Archived Doctor List</h3>
                          <div className="doctor-search-blk">
                            <div className="top-nav-search table-search-blk">
                              <form>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search by name, email, etc."
                                  value={searchText}
                                  onChange={handleSearch}
                                />
                                <Link className="btn">
                                  <FeatherIcon icon="search" />
                                </Link>
                              </form>
                            </div>
                            <div className="add-group d-flex align-items-center">
                              <div
                                className="btn-group me-2"
                                role="group"
                                aria-label="Items per page"
                              >
                                <span className="me-2">Show</span>
                                <select
                                  className="form-control form-select-sm"
                                  value={itemPerPage}
                                  onChange={(e) =>
                                    setItemPerPage(Number(e.target.value))
                                  }
                                  style={{ width: "80px" }}
                                >
                                  <option value={5}>5</option>
                                  <option value={10}>10</option>
                                  <option value={20}>20</option>
                                  <option value={50}>50</option>
                                </select>
                              </div>
                              <Link
                                to="/register-doctor"
                                className="btn btn-primary add-pluss ms-2"
                                title="Add Doctor"
                              >
                                <FeatherIcon icon="plus" />
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* /Table Header */}
                  <div className="table-responsive">
                    <Table
                      pagination={false}
                      columns={columns}
                      dataSource={currentItems}
                      rowKey={(record) => record.doctor_id}
                      loading={loading}
                    />
                  </div>
                  {/* Pagination */}
                  {data.length > 0 && (
                    <div className="card-inner">
                      <nav aria-label="Page navigation">
                        <ul className="pagination justify-content-center mt-3">
                          <li
                            className={`page-item ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => setCurrentPage(currentPage - 1)}
                            >
                              Previous
                            </button>
                          </li>
                          {Array.from(
                            {
                              length: Math.ceil(data.length / itemPerPage),
                            },
                            (_, i) => i + 1
                          ).map((page) => (
                            <li
                              key={page}
                              className={`page-item ${
                                currentPage === page ? "active" : ""
                              }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => setCurrentPage(page)}
                              >
                                {page}
                              </button>
                            </li>
                          ))}
                          <li
                            className={`page-item ${
                              currentPage ===
                              Math.ceil(data.length / itemPerPage)
                                ? "disabled"
                                : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => setCurrentPage(currentPage + 1)}
                            >
                              Next
                            </button>
                          </li>
                        </ul>
                      </nav>
                      <div className="text-center">
                        <span>
                          Showing {indexOfFirstItem + 1} to{" "}
                          {Math.min(indexOfLastItem, data.length)} of{" "}
                          {data.length} entries
                        </span>
                      </div>
                    </div>
                  )}
                  {data.length === 0 && !loading && (
                    <div className="text-center mt-3">
                      <span className="text-muted">No archived doctors found</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArchiveDoctor;